import React, { useState } from "react";

import Chip from "@material-ui/core/Chip";
import CircularProgress from "@material-ui/core/CircularProgress";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import CheckIcon from "@material-ui/icons/Check";

import { STATUS_CONFIG, STATUS_KEYS, normalizeStatus, statusColor, statusLabel } from "./helpers";

/** Chip do selo; com onChange vira clicável e abre o menu com os 4 selos. */
const StatusChip = ({ status, busy = false, onChange }) => {
  const [anchor, setAnchor] = useState(null);
  const current = normalizeStatus(status);
  const clickable = typeof onChange === "function";

  return (
    <>
      <Chip
        size="small"
        style={{ backgroundColor: statusColor(current), color: "#FFF", fontWeight: "bold", cursor: clickable ? "pointer" : "default" }}
        label={busy ? <CircularProgress size={12} style={{ color: "#FFF" }} /> : statusLabel(current)}
        onClick={clickable && !busy ? (event) => setAnchor(event.currentTarget) : undefined}
      />
      {clickable ? (
        <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
          {STATUS_KEYS.map((key) => (
            <MenuItem
              key={key}
              selected={key === current}
              onClick={() => {
                setAnchor(null);
                if (key !== current) onChange(key);
              }}
            >
              <span style={{ width: 24, display: "inline-flex" }}>
                {key === current ? <CheckIcon fontSize="small" /> : null}
              </span>
              {STATUS_CONFIG[key].label}
            </MenuItem>
          ))}
        </Menu>
      ) : null}
    </>
  );
};

export default StatusChip;
